import { StyleSheet } from '@react-pdf/renderer';

export const invoiceItemsStyle = StyleSheet.create({
    container: {
        marginTop: 20,
    },
    tableHeader: {
        flexDirection: 'row',
        paddingVertical: 10,
        paddingHorizontal: 12,
        borderBottomWidth: 1,
        borderBottomColor: '#E4EBFB',
    },
    headerCell: {
        fontSize: 12,
        color: '#676F80',
    },
    descriptionHeader: {
        flex: 3,
    },
    qtyHeader: {
        flex: 1,
        textAlign: 'center',
    },
    rateHeader: {
        flex: 1.5,
        textAlign: 'right',
    },
    taxHeader: {
        flex: 1,
        textAlign: 'right',
    },
    amountHeader: {
        flex: 1.5,
        textAlign: 'right',
    },
    tableRow: {
        flexDirection: 'row',
        paddingVertical: 12,
        paddingHorizontal: 12,
        borderBottomWidth: 1,
        borderBottomColor: '#E4EBFB',
    },
    descriptionCell: {
        flex: 3,
    },
    descriptionTitle: {
        fontSize: 12,
        fontWeight: 'bold',
        color: '#212529',
        marginBottom: 4,
    },
    descriptionSubtitle: {
        fontSize: 10,
        color: '#6c757d',
    },
    qtyCell: {
        flex: 1,
        textAlign: 'center',
        fontSize: 12,
        color: '#676F80',
    },
    rateCell: {
        flex: 1.5,
        textAlign: 'right',
        fontSize: 12,
        color: '#676F80',
    },
    taxCell: {
        flex: 1,
        textAlign: 'right',
        fontSize: 12,
        color: '#676F80',
    },
    amountCell: {
        flex: 1.5,
        textAlign: 'right',
        fontSize: 12,
        color: '#676F80',
    },
    totalsSection: {
        marginTop: 20,
        alignItems: 'flex-end',
        gap: 8,
    },
    totalRow: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '40%',
        paddingVertical: 6,
        borderBottomWidth: 1,
        borderBottomColor: '#E4EBFB',
    },
    totalLastRow: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '40%',
        paddingVertical: 6,
    },
    totalLabel: {
        fontSize: 12,
        color: '#212529',
    },
    totalValue: {
        fontSize: 12,
        color: '#676F80',
    },
    amountDueRow: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '40%',
        paddingVertical: 12,
        borderTopWidth: 2,
        borderTopColor: '#4B99F5',
        borderBottomWidth: 2,
        borderBottomColor: '#4B99F5',
        marginTop: 8,
    },
    amountDueLabel: {
        fontSize: 14,
        color: '#4B99F5',
    },
    amountDueValue: {
        fontSize: 14,
        color: '#4B99F5',
    },
    noteSection: {
        marginTop: 30,
        padding: 16,
    },
    noteText: {
        fontSize: 11,
        color: '#676F80',
        lineHeight: 1.6,
    },
});
